import { z } from 'zod';

import { otpCodeSchema, phoneSchema } from '@/shared/validation/common';

export const requestOtpSchema = z.object({
  phone: phoneSchema,
});
export type RequestOtpForm = z.input<typeof requestOtpSchema>;

export const verifyOtpSchema = z.object({
  code: otpCodeSchema,
});
export type VerifyOtpForm = z.input<typeof verifyOtpSchema>;

export const profileSchema = z.object({
  first_name: z
    .string()
    .trim()
    .max(50, 'نام نباید بیشتر از ۵۰ نویسه باشد')
    .optional()
    .or(z.literal('').transform(() => undefined)),
  last_name: z
    .string()
    .trim()
    .max(50, 'نام خانوادگی نباید بیشتر از ۵۰ نویسه باشد')
    .optional()
    .or(z.literal('').transform(() => undefined)),
});
export type ProfileForm = z.input<typeof profileSchema>;
